function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import tasks from '@/js/tasks';
import { validateError, loginObj } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['analytic_service']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8093')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
setupInterceptors(appApisGTW);
var CONTROLLER_NAME = '/mlops';
var DOMAIN_RESOURCES = '/resources';
var DOMAIN_REQUEST = '/request';
var DOMAIN_CONFIG = '/config';
var DOMAIN_MONITORING = '/monitoring';
var headers = {
  headers: {
    'Content-Type': 'application/json'
  }
};
export default {
  save_request: function save_request() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/save_request"), body, headers).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  update_request: function update_request() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/update_request"), body, headers).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  get_request: function get_request() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/get_request"), body, headers).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  download_file: function download_file() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/download_file"), body, {
      responseType: 'blob'
    }).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  get_configs: function get_configs() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/get_configs"), body, headers).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  get_projects: function get_projects() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/get_projects"), body, headers).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  create_config: function create_config() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/create_config"), body, headers).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  update_config: function update_config() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/update_config"), body, headers).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  delete_config: function delete_config() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/delete_config"), body, headers).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  create_project: function create_project() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/create_project"), body, headers).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  update_project: function update_project() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/update_project"), body, headers).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  },
  delete_project: function delete_project() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var login = loginObj(window.userInfo.email, window.userInfo.accessToken, window.userInfo.localId);
    var body = _objectSpread({
      login: login
    }, data);
    tasks.lockScreen.lock();
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/delete_project"), body, headers).then(function (response) {
      tasks.lockScreen.unlock();
      return response.data;
    });
  }
};